import BookingDetails, {bookingMemberNames} from '../BookingDetails';
import React, {useState} from 'react';
import {Modal} from 'react-bootstrap';
import Moment from 'moment';
import SweetAlert from 'react-bootstrap-sweetalert';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {authCompanyData} from '../../redux/actions';
import {AxiosHelperPortal, BASE_URL_WEB, showToast} from '../../utility';
import {
  classCancellationError,
  clientCanCancelCamp,
  usesMembershipV2Credits,
} from '../../utility/cancellationPolicy';

const DashboardEventsDetailsModal = ({show, onHide, details}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const authDetails = useSelector(state => state.auth);
  const readOnly = details?.readOnly === true
    || Boolean(details?.companyId && details.companyId !== authDetails?.companyData?.id)
    || Boolean(details?.branchId && details.branchId !== (
      authDetails?.companyData?.branch?.id || authDetails?.companyData?.member?.memberActiveBranchId
    ));

  const [showCancelDialog, setShowCancelDialog] = useState(false);

  console.log('details', details);

  const isSessionWithinCutOff = type => {
    const start = details?.start; // Assuming details.start is a UTC date string
    if (!start) return false; // Handle missing start date
    // Parse the input date as UTC using moment-timezone
    const inputDate = Moment.tz(start, 'UTC');
    // Get current UTC time using moment-timezone
    const currentUTC = Moment.utc();
    // Fetch cutoff in hours (assuming the value is in hours, e.g., 48 for 48 hours)
    const cutoffHours = authDetails?.companyData?.[`${type}_days`] || 0;
    // Calculate time difference in milliseconds
    const timeDifference = inputDate.diff(currentUTC);
    // Convert cutoff hours to milliseconds
    const cutoffMilliseconds = cutoffHours * 60 * 60 * 1000;
    console.log(
      'timeDifference',
      timeDifference / (60 * 60 * 1000),
      'cutoffMilliseconds',
      cutoffMilliseconds / (60 * 60 * 1000)
    );
    // Return true if the session start is within the cutoff period (including future dates)
    return timeDifference <= cutoffMilliseconds;
  };
  console.log('details22', authDetails);
  const onCancel = async () => {
    if (readOnly) return;
    if (details.typename === 'group_class_members') {
      if (!clientCanCancelCamp(details)) {
        showToast.error('Please contact the coach to cancel this registration.');
        return;
      }
      const cancellationError = classCancellationError({
        companyData: authDetails?.companyData,
        booking: details,
      });
      if (cancellationError) {
        showToast.error(cancellationError);
        return;
      }
    }
    const payload = {
      cancelAllAppointments: null,
      cancelType: 'session_credit',
      cancelledReason: '',
      partialRefundAmount: null,
      refundType: null,
      isGroupClass: details.typename === 'group_class_members' ? 'yes' : 'no',
      clientPortal: 'yes',
      groupClassId: details.typename === 'group_class_members' ? details?.groupClassId : null,
      orderId: details?.orderId,
      uuid: details?.uuid,
      paymentMethod: null,
      isMember: true,
      from: 'client_portal',
      isFromClient: true,
      start: details?.start,
    };
    const url = `${BASE_URL_WEB}appointment-cancel?`;
    console.log('url', url, payload);
    // eslint-disable-next-line no-unused-vars
    try {
      const response = await AxiosHelperPortal(url, 'post', payload);
      console.log('response', response);
      showToast.success('Your session is cancelled successfully.');
      setShowCancelDialog(false);
      onHide();
      setTimeout(() => {
        dispatch(authCompanyData());
      }, 1000);
    } catch (error) {
      console.log('err123', error.response);
      showToast.error(error.response?.data?.message);
    }
  };
  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="modal-content appt-booking-modal">
          <div className="modal-header">
            <h5 className="modal-title">{`${
              details?.typename === 'group_class_members' ? 'Class Details' : 'Appointment Details'
            }`}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onHide}
            ></button>
          </div>
          <div className="modal-body">
            <BookingDetails
              service={details?.serviceName}
              members={bookingMemberNames(details, authDetails?.companyData?.member)}
              memberLabel={details?.typename === 'group_class_members' ? 'Members Booked' : 'Member Booked'}
              coach={
                details?.trainerName ||
                details?.selectedTrainers
                  ?.map(t => t.trainerName)
                  .filter(Boolean)
                  .join(', ')
              }
              start={details?.start_branch_time}
              end={details?.end_branch_time}
              booking={details}
              showMeetingLink
              showMap
            />

            {readOnly && <p>Please contact the coach about changes to this booking.</p>}
            {!readOnly && <div className="row d-flex col-12 justify-content-center">
              {details?.typename !== 'group_class_members' &&
                !authDetails?.companyData?.CTCM &&
                authDetails?.companyData?.reschedule_days !== null &&
                authDetails?.companyData?.reschedule_days !== undefined && (
                  <button
                    className="btn btn-primary col-4 mr-2"
                    data-bs-dismiss="modal"
                    aria-label="Reschedule"
                    onClick={() => {
                      if (
                        !authDetails?.companyData?.CTCM &&
                        (authDetails?.companyData?.reschedule_days === null ||
                          authDetails?.companyData?.reschedule_days === undefined)
                      ) {
                        showToast.error('Rescheduling is not allowed.');
                        return;
                      } else if (
                        details.typename === 'appointment' &&
                        isSessionWithinCutOff('reschedule')
                      ) {
                        showToast.error(
                          'Appointment cannot be rescheduled within ' +
                            authDetails?.companyData?.reschedule_days +
                            ' hours of start time.'
                        );
                        return;
                      } else {
                        history.push('/reschedule', {details});
                      }
                    }}
                  >
                    Reschedule
                  </button>
                )}

              <button
                className="btn btn-primary col-4 ml-2"
                data-bs-dismiss="modal"
                aria-label="Cancel"
                onClick={() => {
                  if (details.typename === 'group_class_members') {
                    if (!clientCanCancelCamp(details)) {
                      showToast.error('Please contact the coach to cancel this registration.');
                      return;
                    }
                    const cancellationError = classCancellationError({
                      companyData: authDetails?.companyData,
                      booking: details,
                    });
                    if (cancellationError) {
                      showToast.error(cancellationError);
                      return;
                    }
                  } else if (authDetails?.companyData?.CTCM === true) {
                    showToast.error('Please contact your coach to cancel this session.');
                    return;
                  } else if (
                    !authDetails?.companyData?.CTCM &&
                    (authDetails?.companyData?.cancel_days === null ||
                      authDetails?.companyData?.cancel_days === undefined)
                  ) {
                    showToast.error('Please contact your coach to cancel this session.');
                    return;
                  }else if (
                    details.typename === 'appointment' &&
                    isSessionWithinCutOff('cancel')
                  ) {
                    showToast.error(
                      'Appointment cannot be cancelled within ' +
                        authDetails?.companyData?.cancel_days +
                        ' hours of start time.'
                    );
                    return;
                  }

                  setShowCancelDialog(!showCancelDialog);
                }}
              >
                Cancel
              </button>
            </div>}
          </div>
        </div>
      </Modal>
      {showCancelDialog && (
        <SweetAlert
          showCancel
          confirmBtnText="Cancel and receive credit"
          title={
            <div className="alert alert-warning" style={{fontSize: '14px', lineHeight: '1.2', margin: 0, textAlign: 'left'}}>
              {usesMembershipV2Credits(details)
                ? 'When you cancel, the credit will be returned to the membership with its original restrictions.'
                : 'When you cancel, you will receive a credit for the service. To receive a refund, please contact your coach and ask them to cancel this service for you.'}
            </div>
          }
          onConfirm={onCancel}
          onCancel={() => setShowCancelDialog(!showCancelDialog)}
          focusCancelBtn
          cancelBtnText="Back"
        />
      )}
    </>
  );
};

export default DashboardEventsDetailsModal;
